export class RankingService {
  constructor(rankingRepository) {
    this.rankingRepository = rankingRepository;
  }

  async getSupplementsRanking(params = {}) {
    return await this.rankingRepository.getSupplementsRanking(params);
  }

  async getMedicationsRanking(params = {}) {
    return await this.rankingRepository.getMedicationsRanking(params);
  }

  async getProductRanking(params = {}) {
    return await this.rankingRepository.getProductRanking(params);
  }

  async getProductTrend(productId, params = {}) {
    return await this.rankingRepository.getProductTrend(productId, params);
  }

  async getSearchTrend(params = {}) {
    return await this.rankingRepository.getSearchTrend(params);
  }

  async getHighlights() {
    return await this.rankingRepository.getHighlights();
  }

  async getMyProducts(params = {}) {
    return await this.rankingRepository.getMyProducts(params);
  }

  async getProductDetail(productId) {
    return await this.rankingRepository.getProductDetail(productId);
  }
}
